import { Box, Typography } from '@mui/material';
import React from 'react';
import { FREE_BENEFITS } from 'shared/constants/subscriptions/plans';

import { EquinetCore, TickIcon } from '@/assets/svg';
import { Button } from '@/components';
import { t } from '@/services/translations/config';
import { COLOR } from '@/theme/colors';

import { PlanBenefits } from '../PlanBenefits';
import { planStyles } from '../planStyles';

const CorePlan: React.FC = () => {
    return (
        <Box sx={planStyles.wrapper}>
            <Box
                sx={{
                    ...planStyles.container,
                    background: `linear-gradient(180deg, ${COLOR.porcelain}, ${COLOR.porcelainLigth})`,
                }}
            >
                <Box
                    sx={{
                        ...planStyles.box,
                        backgroundColor: COLOR.white,
                        border: `1px solid ${COLOR.fiord}`,
                    }}
                >
                    <Typography color={COLOR.fiord} fontSize={10}>
                        {t('PremiumPage:subscriptionPlans:core:label')}
                    </Typography>
                </Box>

                <Box
                    sx={{
                        display: 'flex',
                        flexDirection: 'column',
                        gap: '8px',
                    }}
                >
                    <EquinetCore color={COLOR.black} width={210} />
                </Box>

                <Typography fontSize={12} color={COLOR.slateGray}>
                    {t('PremiumPage:subscriptionPlans:core:description')}
                </Typography>

                <Box>
                    <Typography fontSize={24} fontWeight={700}>
                        {t('SubscriptionDetails:free')}
                    </Typography>
                    <Typography fontSize={11} color={COLOR.slateGray}>
                        /{' '}
                        {t(
                            'PremiumPage:subscriptionPlans:core:priceDescription',
                        )}
                    </Typography>
                </Box>

                <Button
                    sx={{
                        fontSize: 12,
                        fontWeight: 400,
                        background: 'inherit',
                        borderRadius: '50px',
                        mt: 'auto',
                        color: COLOR.slateGray,
                        borderColor: COLOR.geyser,
                    }}
                    variant="outlined"
                    startIcon={
                        <TickIcon color={COLOR.ghost} width={20} height={20} />
                    }
                    caption={t('PremiumPage:subscriptionPlans:core:button')}
                    // eslint-disable-next-line
                    onClick={() => {}}
                    disabled
                />
            </Box>

            <PlanBenefits
                benefits={FREE_BENEFITS}
                title={t('PremiumPage:subscriptionPlans:core:benefits')}
            />
        </Box>
    );
};

export default CorePlan;
